import React, { memo, useEffect, useState } from 'react';
import { TTForm } from '../../interfaces/forms';
import { Form } from '@rjsf/antd';
import validator from '@rjsf/validator-ajv8';
import { ConfigProvider, message } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../rootReducer';
import { TTRestaurantProfile } from '../../interfaces/restaurant';
import CustomTitleTemplate from './TitleTemplate';
import CustomDatetimeWidget from './DateTimeFormInput';
type Props = {
  form: TTForm;
  onDone: (formData) => void;
};

const safelyParseJSON = (localStorageKey: string) => {
  try {
    const data = localStorage.getItem(localStorageKey);
    return JSON.parse(data);
  } catch (error) {
    console.error(`Failed to parse data from ${localStorageKey}`, error);
    return {};
  }
};

const deepCompare = (obj1, obj2) => {
  if (obj1 === obj2) {
    return true;
  }
  if (
    typeof obj1 !== 'object' ||
    obj1 === null ||
    typeof obj1 === 'function' ||
    typeof obj2 !== 'object' ||
    obj2 === null ||
    typeof obj2 === 'function'
  ) {
    return false;
  }
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }
  for (const key in obj1) {
    if (!deepCompare(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
};

export function FormView({ form, onDone }: Props) {
  const [properties, setProperties] = useState([]);
  const [propertyUI, setPropertyUI] = useState({});
  const profile = useSelector<RootState, TTRestaurantProfile | null>(
    state => state.restaurant.profile,
  );
  const [formData, setFormData] = useState(safelyParseJSON(`form_${form.id}`));

  useEffect(() => {
    setProperties(Object.keys(form.form_schema?.properties ?? {}));
    let update = {};
    Object.keys(form.form_schema?.properties ?? {}).forEach(p => {
      update[p] = {
        'ui:classNames': 'text-on-secondary text-lg font-semibold',
      };
    });
    setPropertyUI(update);
  }, []);

  const handle = (formData: any) => {
    onDone(formData);
  };
  return (
    <div className="px-4  pt-2 rounded-md shadow-md bg-primary-container/20 mx-4 py-4">
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: profile?.custom_theme?.sourceColor,
          },
        }}
      >
        <Form
          formData={formData}
          schema={form.form_schema}
          widgets={{
            DateTimeWidget: CustomDatetimeWidget,
            DateWidget: CustomDatetimeWidget,
            TimeWidget: CustomDatetimeWidget,
          }}
          onChange={e => {
            setFormData({ ...formData, ...e.formData });
          }}
          templates={{
            TitleFieldTemplate: CustomTitleTemplate,
          }}
          uiSchema={{
            ...form.ui_schema,
            'ui:classNames':
              'text-on-secondary-container font-semibold rounded-md ',
            'ui:options': {
              ...propertyUI,
            },

            'ui:submitButtonOptions': {
              ...form.ui_schema['ui:submitButtonOptions'],
              props: {
                className: 'bg-tertiary text-on-tertiary w-full',
              },
            },
          }}
          onSubmit={e => {
            localStorage.setItem(`form_${form.id}`, JSON.stringify(e.formData));
            setFormData(e.formData);
            handle(e.formData);
          }}
          validator={validator}
        />
      </ConfigProvider>
    </div>
  );
}
